import { createContext, type PropsWithChildren, useContext } from "react";

import type { AppEnvironment } from "./environment.js";

const EnvironmentContext = createContext<AppEnvironment | null>(null);

export function EnvironmentProvider({
  children,
  environment,
}: PropsWithChildren<{ readonly environment: AppEnvironment }>) {
  return <EnvironmentContext.Provider value={environment}>{children}</EnvironmentContext.Provider>;
}

export function useEnvironment(): AppEnvironment {
  const environment = useContext(EnvironmentContext);
  if (environment === null)
    throw new Error("useEnvironment must be used inside EnvironmentProvider.");
  return environment;
}
